module.exports = __webpack_public_path__ + "img/xlsx.464c5c3b.svg";